const defaultTheme = {
  button: {
    base:
      'font-montserrat font-bold uppercase text-base leading-1.1875em rounded-lg 2xl:text-xl 2xl:rounded-2xl',
    fill: {
      primary:
        'px-3.5 py-1.5 bg-enterpriseOrange-500 text-white border-2 border-white hover:bg-enterpriseOrange-800 2xl:border-4 2xl:p-3 focus:outline-none focus:ring-2 ring-enterpriseOrange-500',
      secondary:
        'px-3.5 py-1.5 bg-white text-enterpriseOrange-500 border-2 border-white hover:bg-enterpriseOrange-500 hover:text-white 2xl:border-4 2xl:p-3 focus:outline-none focus:ring-2 ring-enterpriseOrange-500',
      // no design yet
      tertiary: '',
    },
    outline: {
      primary:
        'px-3.5 py-1.5 text-white border-2 border-white hover:bg-enterpriseOrange-500 bg-transparent 2xl:border-4 2xl:p-3',
      // no design yet
      secondary:
        'px-3.5 py-1.5 text-enterpriseOrange-500 border-2 border-enterpriseOrange-500 hover:text-white hover:border-white bg-transparent 2xl:border-4 2xl:p-3',
      tertiary: '',
    },
    text: {
      primary: '',
      secondary: '',
      tertiary: '',
    },
    link: {
      primary: '',
      secondary: '',
      tertiary: '',
    },
    icon: {
      primary: 'hover:bg-gray-200 rounded-full p-2.5 focus:outline-none',
      secondary: '',
      tertiary: '',
    },
  },
  backdrop: {
    base:
      'fixed inset-0 z-40 bg-black bg-opacity-50 flex items-center justify-center',
  },
  modal: {
    base:
      'relative flex flex-col min-h-80 bg-white bg-opacity-90 text-black rounded-lg z-50 2xl:w-176 max-h-screen',
    header:
      'font-montserrat font-bold mx-5 mt-5 flex-grow-0 text-2xl 2xl:mx-12 2xl:mt-8 2xl:text-3.5xl',
    body: 'm-5 flex-grow overflow-y-auto 2xl:mx-12 2xl:mt-8',
    footer: '',
  },
  input: {
    base:
      'rounded-lg 2xl:rounded-2xl text-sm leading-1.3em px-4 py-2 w-full font-montserrat font-bold max-h-screen 2xl:py-3.5 2xl:text-base 2xl:leading-1.2em',
    fill: {
      primary:
        'text-gray-700 border-2 border-techsicoGray-500 placeholder-gray-400 hover:border-opacity-80 focus:outline-none focus:border-enterpriseOrange-500',
    },
    outline: {
      primary:
        'bg-transparent placeholder-white text-white border-white border-4 focus:border-enterpriseOrange-500',
    },
  },
  select: {
    base: 'appearance-none',
  },
};

export default defaultTheme;
